import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CustomRolesAPI from '../../api/customRoles';

export const state = {
  records: [],
  availablePermissions: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCustomRoles(_state) {
    return _state.records;
  },
  getAvailablePermissions(_state) {
    return _state.availablePermissions;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCustomRoleById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getCustomRoles({ commit }) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isFetching: true });
    try {
      const response = await CustomRolesAPI.get();
      commit(types.SET_CUSTOM_ROLE, response.data);
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isFetching: false });
    }
  },

  getAvailablePermissions: async function getAvailablePermissions({ commit }) {
    const response = await CustomRolesAPI.availablePermissions();
    commit(types.SET_CUSTOM_ROLE_PERMISSIONS, response.data.payload);
  },

  create: async function createCustomRole({ commit }, customRole) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isCreating: true });
    try {
      const response = await CustomRolesAPI.create({ custom_role: customRole });
      commit(types.ADD_CUSTOM_ROLE, response.data);
      return response.data;
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateCustomRole({ commit }, { id, ...customRole }) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isUpdating: true });
    try {
      const response = await CustomRolesAPI.update(id, {
        custom_role: customRole,
      });
      commit(types.EDIT_CUSTOM_ROLE, response.data);
      return response.data;
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteCustomRole({ commit }, id) {
    commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isDeleting: true });
    try {
      await CustomRolesAPI.delete(id);
      commit(types.DELETE_CUSTOM_ROLE, id);
    } finally {
      commit(types.SET_CUSTOM_ROLE_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CUSTOM_ROLE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CUSTOM_ROLE_PERMISSIONS](_state, data) {
    _state.availablePermissions = data;
  },

  // Nome singular, lista no plural: a chave veio do enterprise e foi reaproveitada em vez de
  // duplicada com nome melhor.
  [types.SET_CUSTOM_ROLE]: MutationHelpers.set,
  [types.ADD_CUSTOM_ROLE]: MutationHelpers.create,
  [types.EDIT_CUSTOM_ROLE]: MutationHelpers.update,
  [types.DELETE_CUSTOM_ROLE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
